import React from 'react';
import { Facebook, Instagram, Twitter, Youtube, Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer id="footer" className="bg-[#0A0A0A] text-cream pt-20 pb-8 px-6 lg:px-12 font-sans" data-id="element-53">
      <div className="max-w-[1400px] mx-auto" data-id="element-54">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-20" data-id="element-55">
          {/* Column 1: Brand */}
          <div className="flex flex-col gap-6" data-id="element-56">
            <h2 className="font-serif text-3xl tracking-wide" data-id="element-57">
              Parkway <span className="italic text-taupe" data-id="element-58">ESTHETICS</span>
            </h2>
            <p className="text-sm text-cream/60 leading-relaxed" data-id="element-59">
              Our experts bring a wealth of knowledge and hands-on experience,
              ensuring you receive the most comprehensive and effective
              education available.
            </p>
            <div className="flex items-center gap-4 mt-2" data-id="element-60">
              <a href="#" className="text-cream hover:text-taupe transition-colors" data-id="element-61">
                <Facebook size={20} data-id="element-62" />
              </a>
              <a href="#" className="text-cream hover:text-taupe transition-colors" data-id="element-63">
                <Instagram size={20} data-id="element-64" />
              </a>
              <a href="#" className="text-cream hover:text-taupe transition-colors" data-id="element-65">
                <Twitter size={20} data-id="element-66" />
              </a>
              <a href="#" className="text-cream hover:text-taupe transition-colors" data-id="element-67">
                <Youtube size={20} data-id="element-68" />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col gap-6" data-id="element-69">
            <h3 className="font-serif text-xl text-taupe" data-id="element-70">Quick Links</h3>
            <ul className="flex flex-col gap-3 text-sm text-cream/80" data-id="element-71">
              {['Home', 'Services', 'Before & After', 'Training', 'About Us', 'Book Appointment', 'FAQs'].map((link, idx) => <li key={idx} data-id="element-72">
                  <a href="#" className="flex items-center gap-2 hover:text-taupe transition-colors group" data-id="element-73">
                    <span className="text-taupe/50 group-hover:translate-x-1 transition-transform" data-id="element-74">
                      →
                    </span>
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3: Services */}
          <div className="flex flex-col gap-6" data-id="element-75">
            <h3 className="font-serif text-xl text-taupe" data-id="element-76">Services</h3>
            <ul className="flex flex-col gap-3 text-sm text-cream/80" data-id="element-77">
              {['Scar Camouflage', 'Facial Camouflage', 'Areola Restoration', 'Birth Marks Camouflage', 'Stretch Mark Microneedling', 'Stretch Mark Camouflage', 'Vitiligo Camouflage', 'Tattoo Laser Removal'].map((link, idx) => <li key={idx} data-id="element-78">
                  <a href="#" className="flex items-center gap-2 hover:text-taupe transition-colors group" data-id="element-79">
                    <span className="text-taupe/50 group-hover:translate-x-1 transition-transform" data-id="element-80">
                      →
                    </span>
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 4: Information */}
          <div className="flex flex-col gap-6" data-id="element-81">
            <h3 className="font-serif text-xl text-taupe" data-id="element-82">Information</h3>

            <div className="flex items-start gap-4 text-sm text-cream/80" data-id="element-83">
              <Phone size={18} className="text-taupe flex-shrink-0 mt-1" data-id="element-84" />
              <div data-id="element-85">
                <p className="font-medium text-cream mb-1" data-id="element-86">Phone</p>
                <a href="tel:+17269007476" className="hover:text-taupe transition-colors block" data-id="element-87">
                  +1 726-900-7476
                </a>
                <span className="text-xs text-cream/50 mt-1 block" data-id="element-88">
                  Text START to subscribe to our text message list
                </span>
              </div>
            </div>

            <div className="flex items-start gap-4 text-sm text-cream/80" data-id="element-89">
              <Mail size={18} className="text-taupe flex-shrink-0 mt-1" data-id="element-90" />
              <div data-id="element-91">
                <p className="font-medium text-cream mb-1" data-id="element-92">Email</p>
                <a href="mailto:info@parkwayesthetics.com" className="hover:text-taupe transition-colors block" data-id="element-93">
                  info@parkwayesthetics.com
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4 text-sm text-cream/80" data-id="element-94">
              <MapPin size={18} className="text-taupe flex-shrink-0 mt-1" data-id="element-95" />
              <div data-id="element-96">
                <p className="font-medium text-cream mb-1" data-id="element-97">Address</p>
                <p className="leading-relaxed" data-id="element-98">
                  2576 Montessouri Street, Suite 110
                  <br data-id="element-99" />
                  Las Vegas, Nevada, 89117
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-cream/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-cream/50" data-id="element-100">
          <p data-id="element-101">2024 © Parkway Esthetics. All Rights Reserved.</p>
          <div className="flex gap-4" data-id="element-102">
            <a href="#" className="hover:text-taupe transition-colors" data-id="element-103">
              Home
            </a>
            <span data-id="element-104">·</span>
            <a href="#" className="hover:text-taupe transition-colors" data-id="element-105">
              Privacy Policy
            </a>
            <span data-id="element-106">·</span>
            <a href="#" className="hover:text-taupe transition-colors" data-id="element-107">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>;
}